import React, { useState, useEffect } from "react";
import { useFormik } from 'formik';
import axios from 'axios';
import { BASE_URL, POST_GENERAL_SETTINGS, GET_MASTER_DATA } from '../utlilities/config'; 
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getWebUserInfo, initializeWebUserInfo } from "../utlilities/webConfig";
import { 
  FiAlertCircle, FiPrinter, FiFileText, 
  FiClock, FiMap, FiPhone, FiUser, FiSave, FiInfo,
  FiBriefcase, FiHome, FiCheckSquare, FiSliders
} from 'react-icons/fi';

const AdminSettings = () => {
    const [loading, setLoading] = useState(false);
    const [generalopSettings, setGeneralopSettings] = useState({});
    const [outlets, setOutlets] = useState([]);

    const [generalSettings, setGeneralSettings] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const token = localStorage.getItem('accessToken');

    const isElectron = () => {
      return window && window.process && window.process.type;
    };
  
    let ipcRenderer;
  
    if (isElectron()) {
        ipcRenderer = window.require('electron').ipcRenderer;
    }


    useEffect(() => {
      const handleWheel = (e) => {
        if (e.target.type === 'number') {
          e.target.blur();
        }
      };
  
      const handleKeyDown = (e) => {
        if (e.target.type === 'number') {
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
          }
        }
      };
  
      document.addEventListener('wheel', handleWheel, { capture: true });
      document.addEventListener('keydown', handleKeyDown, { capture: true });
  
      return () => {
        document.removeEventListener('wheel', handleWheel, { capture: true });
        document.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
    }, []);
  
    useEffect(() => {
      const fetchData = async () => {
        let settings;
        let settings1;
  
        if (isElectron()) {
          settings1 = await ipcRenderer.invoke('store-get', 'generalsettings');

          settings = await ipcRenderer.invoke('store-get', 'generalopsettings');

          console.log('generalSettings', settings1)
          console.log('generalopsettings', settings)

          setGeneralopSettings(settings || {});
          setGeneralSettings(settings1 || {});
        } else {
            initializeWebUserInfo();
            settings = getWebUserInfo().generalopsettings; // Fetch from webConfig
            setGeneralopSettings(settings || {});

            settings1 = getWebUserInfo().generalSettings;
            setGeneralSettings(settings1 || {});
        }
        setDataLoaded(true);
      };
  
      fetchData();
    }, []);

    useEffect(() => {
      getData();
    }, []);
  
    const getData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}${GET_MASTER_DATA}`, {
          headers: {
            'XApiKey': process.env.REACT_APP_API_KEY,
            'Authorization': `Bearer ${token}`
          },
        });
  
        if (response.status === 200) {
          setLoading(false);
          console.log('response',response.data.data.filter(item => item.Type === 'D'));
          setOutlets((response.data.data || []).filter(item => item.Type === 'D'));
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error('Failed to fetch labs data:', error);
        toast.error('Could not load labs data', {
          autoClose: 1000,
          icon: <FiAlertCircle className="text-red-500" />
        });
      } finally {
        setLoading(false);
      }
    };
    
    const formik = useFormik({
      initialValues: {
        AddressLine1: '',
        AddressLine2: '',
        FirstName: '',
        LastName: '',
        MobileNo1: '',
        MobileNo2: '',
        Place: '',
        WorkingTime: '',

        phAutoBillPrint: '',
        phBillTemplate: '',
        phBillType: '',
        phPrinterType: '',
        phPrinterWidth: '',
        phpaymentMarkOnBillSave: '',
        GstNo: '',
        phShowFirmname: false,
        phShowFirmnumber: false,
        phShowAddress: false,
        phShowGst: false,
        phShowWorkingHourse: false,
        phShowUsername: false,
        dlnum1: '',
        dlnum2: '',
        phReturnValidityDays: '',
        phExpiryDays: '',
        phFeedinLines : '',
        phFeedInForward : '',
        phFeedOutLines : '',
        phFeedOutForward: '',
        phValueRoundOff : false,
        GbAutoBillPrint: '',
        GbBillTemplate: '',
        GbBillType: '',
        GbPaymentMarkOnBillSave: '',
        PhMedicineFilterType: '',
        GlobalDiscountonSales: 'No',
        phDefaultOutlet: '',
        phDefaultOutletId: '',
      },
      enableReinitialize: false, // Changed to false
      onSubmit: async (values, { setSubmitting }) => {
        try {
          setLoading(true);

          const data = {
            ClientID: generalSettings?.ClientID || '',
            AddressLine1: values.AddressLine1,
            AddressLine2: values.AddressLine2,
            FirstName: values.FirstName,
            LastName: values.LastName,
            MobileNo1: values.MobileNo1,
            MobileNo2: values.MobileNo2,
            Place: values.Place,
            WorkingTime: values.WorkingTime,
            phAutoBillPrint: values.phAutoBillPrint,
            phBillTemplate: values.phBillTemplate,
            phBillType: values.phBillType,
            phpaymentMarkOnBillSave: values.phpaymentMarkOnBillSave,
            phShowFirmname: values.phShowFirmname,
            phShowFirmnumber: values.phShowFirmnumber,
            phShowAddress: values.phShowAddress,
            phShowGst: values.phShowGst,
            phShowWorkingHourse: values.phShowWorkingHourse,
            phShowUsername: values.phShowUsername,
            phValueRoundOff: values.phValueRoundOff,
            dlnum1: values.dlnum1,
            dlnum2: values.dlnum2,
            phReturnValidityDays: values.phReturnValidityDays,
            phExpiryDays: values.phExpiryDays,
            phPrinterType: values.phPrinterType,
            phPrinterWidth: values.phPrinterWidth,
            phFeedinLines: values.phFeedinLines,
            phFeedInForward: values.phFeedInForward,
            phFeedOutLines: values.phFeedOutLines,
            phFeedOutForward: values.phFeedOutForward,
            GstNo: values.GstNo,
            GbAutoBillPrint: values.GbAutoBillPrint,
            GbBillTemplate: values.GbBillTemplate,
            GbBillType: values.GbBillType,
            GbPaymentMarkOnBillSave: values.GbPaymentMarkOnBillSave,
            PhMedicineFilterType: values.PhMedicineFilterType,
            GlobalDiscountonSales: values.GlobalDiscountonSales || 'No',
            phDefaultOutlet: values.phDefaultOutlet, 
            phDefaultOutletId: values.phDefaultOutletId,
            ShowQRonBill: generalopSettings.ShowQRonBill,
            OpcardTopMargin: generalopSettings.OpcardTopMargin,
            OpcardBottomMargin: generalopSettings.OpcardBottomMargin,
            OpcardLeftMargin: generalopSettings.OpcardLeftMargin,
            OpcardRightMargin: generalopSettings.OpcardRightMargin,
            vitalsRightmargin: generalopSettings.vitalsRightmargin,
            opcardTopborder: generalopSettings.opcardTopborder,
            opcardBottomborder: generalopSettings.opcardBottomborder,
            showVitals: generalopSettings.showVitals,
            AutoBillPrint: generalopSettings.AutoBillPrint,
            AutoRecieptPrint: generalopSettings.AutoRecieptPrint,
            AutoOpcardPrint: generalopSettings.AutoOpcardPrint,
            BillTemplate: generalopSettings.BillTemplate,
            OpcardTemplate: generalopSettings.OpcardTemplate,
            BillType: generalopSettings.BillType,
            OpcardType: generalopSettings.OpcardType,
            RecieptType: generalopSettings.RecieptType,
            RecieptTemplate: generalopSettings.RecieptTemplate,
            paymentMarkOnOpSave: generalopSettings.paymentMarkOnOpSave,
            paymentMarkOnBillSave: generalopSettings.paymentMarkOnBillSave,
            ShowFirmname: generalopSettings.ShowFirmname,
            ShowFirmnumber: generalopSettings.ShowFirmnumber,
            ShowAddress : generalopSettings.ShowAddress,
            ShowGst: generalopSettings.ShowGst,
            ShowWorkingHourse: generalopSettings.ShowWorkingHourse,
            ShowUsername : generalopSettings.ShowUsername,
            ShowToken: generalopSettings.ShowToken,
            showValidityDays: generalopSettings.showValidityDays,
            InitialBookingStatus: generalopSettings.InitialBookingStatus,
            ShowBarcodeinOpcard: generalopSettings.ShowBarcodeinOpcard,
            DoctorBillType: generalopSettings.DoctorBillType,
            DoctorBillTemplate: generalopSettings.DoctorBillTemplate,
            AutoDoctorBillPrint: generalopSettings.AutoDoctorBillPrint,
            AutoDentalBillPrint: generalopSettings.AutoDentalBillPrint,
            NetWorkKotPrinterName : generalopSettings.NetWorkKotPrinterName,
            ObservationChargeType : generalopSettings.ObservationChargeType,
            approvalNeededOpEntryCancel: generalopSettings.approvalNeededOpEntryCancel,
            approvalNeededGeneralBillCancel: generalopSettings.approvalNeededGeneralBillCancel,
            approvalNeededLabEntryCancel: generalopSettings.approvalNeededLabEntryCancel,
            approvalNeededPharmacyBillCancel: generalopSettings.approvalNeededPharmacyBillCancel,
            approvalNeededPaymentReceiptCancel: generalopSettings.approvalNeededPaymentReceiptCancel,
            approvalNeededExpenseEntryDelete: generalopSettings.approvalNeededExpenseEntryDelete,
            billPrintonlyPaymentsave: generalopSettings.billPrintonlyPaymentsave,
          };

          const updatedGeneralSettings = {
            ...generalSettings,
            ReceptionSettings: [data]
          };

          console.log('hereeee dtaaaa', updatedGeneralSettings)

          const response = await axios.post(`${BASE_URL}${POST_GENERAL_SETTINGS}`, updatedGeneralSettings, {
            headers: {
              'XApiKey': process.env.REACT_APP_API_KEY,
              'Authorization': `Bearer ${token}`,
            },
          });

          if(response.status === 200) {
            toast.success('Settings saved successfully!', {
              autoClose: 1000,
              icon: '✅',
            });
            
            if(isElectron()) {
              await ipcRenderer.invoke('store-set', 'generalopsettings', data);
            }
          }
    
        } catch (error) {
          setLoading(false);
          toast.error(error.response?.data?.message || 'An error occurred', {
            autoClose: 1000,
          });
          console.log(error);
        } finally {
          setLoading(false);
          setSubmitting(false);
        }
      },
    });

    // Set initial values when data is loaded
    useEffect(() => {
      if (dataLoaded && generalopSettings) {
        formik.setValues({
            AddressLine1: generalopSettings.AddressLine1 || '',
            AddressLine2: generalopSettings.AddressLine2 || '',
            FirstName: generalopSettings.FirstName || '',
            LastName: generalopSettings.LastName || '',
            MobileNo1: generalopSettings.MobileNo1 || '',
            MobileNo2: generalopSettings.MobileNo2 || '',
            Place: generalopSettings.Place || '',
            WorkingTime: generalopSettings.WorkingTime || '',
            phAutoBillPrint: generalopSettings.phAutoBillPrint || '',
            phBillTemplate: generalopSettings.phBillTemplate || '',
            phBillType: generalopSettings.phBillType || '',
            phPrinterType: generalopSettings.phPrinterType || '',
            phPrinterWidth: generalopSettings.phPrinterWidth || '',
            phpaymentMarkOnBillSave: generalopSettings.phpaymentMarkOnBillSave || '',
            GstNo: generalopSettings.GstNo || '',
            OpHeaderImageUrl: generalopSettings.OpHeaderImageUrl || '',
            OpFooterImageUrl: generalopSettings.OpFooterImageUrl || '',
            OpHeaderCloudImageUrl: generalopSettings.OpHeaderCloudImageUrl || '',
            OpFooterCloudImageUrl: generalopSettings.OpFooterCloudImageUrl || '',
            phShowFirmname: generalopSettings.phShowFirmname || false,
            phShowFirmnumber: generalopSettings.phShowFirmnumber || false,
            phShowAddress: generalopSettings.phShowAddress || false,
            phShowGst: generalopSettings.phShowGst || false,
            phShowWorkingHourse: generalopSettings.phShowWorkingHourse || false,
            phShowUsername: generalopSettings.phShowUsername || false,
            dlnum1: generalopSettings.dlnum1 || '',
            dlnum2: generalopSettings.dlnum2 || '',
            phReturnValidityDays: generalopSettings.phReturnValidityDays || '',
            phExpiryDays: generalopSettings.phExpiryDays || '',
            phFeedinLines: generalopSettings.phFeedinLines || '',
            phFeedInForward: generalopSettings.phFeedInForward || '',
            phFeedOutLines: generalopSettings.phFeedOutLines || '',
            phFeedOutForward: generalopSettings.phFeedOutForward || '',
            phValueRoundOff: generalopSettings.phValueRoundOff || false,
            GbAutoBillPrint: generalopSettings.GbAutoBillPrint || '',
            GbBillTemplate: generalopSettings.GbBillTemplate || '',
            GbBillType: generalopSettings.GbBillType || '',
            GbPaymentMarkOnBillSave: generalopSettings.GbPaymentMarkOnBillSave || '',
            PhMedicineFilterType: generalopSettings.PhMedicineFilterType || '',
            GlobalDiscountonSales: generalopSettings.GlobalDiscountonSales || 'No',
            phDefaultOutlet: generalopSettings.phDefaultOutlet || '',
            phDefaultOutletId: generalopSettings.phDefaultOutletId || '',
        });
      }
    }, [dataLoaded, generalopSettings]);

    // Loading indicator component
    const LoadingSpinner = () => (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
          <p className="text-indigo-600 font-medium">Saving settings...</p>
        </div>
      </div>
    );

    // Section title component
    const SectionTitle = ({ icon, title }) => (
      <div className="flex items-center mb-4 pb-2 border-b border-gray-100">
        {icon}
        <h3 className="text-lg font-semibold text-gray-800 ml-2">{title}</h3>
      </div>
    );

    // Don't render form until data is loaded
    if (!dataLoaded) {
      return (
        <div className="p-6">
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="p-6">
        <ToastContainer
          position="top-center"
          autoClose={1000}
          limit={1}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Slide}
        />
        
        {loading && <LoadingSpinner />}
        
        <div className="bg-indigo-50 p-4 rounded-xl mb-3">
          <div className="flex items-start">
            <FiInfo className="text-indigo-600 mt-1 mr-3 flex-shrink-0" size={20} />
            <div>
              <h3 className="font-medium text-indigo-800 mb-1">Admin Settings</h3>
              <p className="text-sm text-indigo-700">
                Configure general reception settings, including printer options, document formatting, and contact information.
              </p>
            </div>
          </div>
        </div>
        
        <form onSubmit={formik.handleSubmit} className="space-y-4">
          {/* Organization Information Section */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <SectionTitle icon={<FiBriefcase className="text-indigo-600" />} title="Organization Information" />
            
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <div>
                <label htmlFor="firstName" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiUser className="text-black" size={16} />
                  <span className="ml-2">Firm First Name</span>
                </label>
                <input
                  type="text"
                  name="FirstName"
                  id="firstName"
                  placeholder="Enter first name"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.FirstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              
              <div>
                <label htmlFor="lastName" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiUser className="text-black" size={16} />
                  <span className="ml-2">Firm Last Name</span>
                </label>
                <input
                  type="text"
                  name="LastName"
                  id="lastName"
                  placeholder="Enter last name"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.LastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              
              <div>
                <label htmlFor="mobileNo1" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiPhone className="text-black" size={16} />
                  <span className="ml-2">Phone Number 1</span>
                </label>
                <input
                  type="text"
                  name="MobileNo1"
                  id="mobileNo1"
                  placeholder="Enter primary phone"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.MobileNo1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              
              <div>
                <label htmlFor="mobileNo2" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiPhone className="text-black" size={16} />
                  <span className="ml-2">Phone Number 2</span>
                </label>
                <input
                  type="text"
                  name="MobileNo2"
                  id="mobileNo2"
                  placeholder="Enter secondary phone"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.MobileNo2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              
              <div>
                <label htmlFor="addressLine1" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiHome className="text-black" size={16} />
                  <span className="ml-2">Address Line 1</span>
                </label>
                <input
                  type="text"
                  name="AddressLine1"
                  id="addressLine1"
                  placeholder="Enter address line 1"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.AddressLine1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              
              <div>
                <label htmlFor="addressLine2" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiHome className="text-black" size={16} />
                  <span className="ml-2">Address Line 2</span>
                </label>
                <input
                  type="text"
                  name="AddressLine2"
                  id="addressLine2"
                  placeholder="Enter address line 2"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.AddressLine2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              
              <div>
                <label htmlFor="place" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiMap className="text-black" size={16} />
                  <span className="ml-2">Place</span>
                </label>
                <input
                  type="text"
                  name="Place"
                  id="place"
                  placeholder="Enter place"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.Place}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>


              <div>
                <label htmlFor="workingTime" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiClock className="text-black" size={16} />
                  <span className="ml-2">Working Time</span>
                </label>
                <input
                  type="text"
                  name="WorkingTime"
                  id="workingTime"
                  placeholder="e.g. 9:00 AM - 6:00 PM"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.WorkingTime}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>

              <div>
                <label htmlFor="dlnum1" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiUser className="text-black" size={16} />
                  <span className="ml-2">DL Number 1</span>
                </label>
                <input
                  type="text"
                  name="dlnum1"
                  id="dlnum1"
                  placeholder="Enter DL number 1"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.dlnum1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>

              <div>
                <label htmlFor="dlnum2" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiUser className="text-black" size={16} />
                  <span className="ml-2">DL Number 2</span>
                </label>
                <input
                  type="text"
                  name="dlnum2"
                  id="dlnum2"
                  placeholder="Enter DL number 2"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.dlnum2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>



              <div>
                <label htmlFor="phReturnValidityDays" className=" text-sm font-medium text-black mb-2 flex items-center">
                  <FiClock className="text-black" size={16} />
                  <span className="ml-2">Return Validity Days</span>
                </label>
                <input
                  type="number"
                  name="phReturnValidityDays"
                  id="phReturnValidityDays"
                  placeholder="Enter return validity days"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phReturnValidityDays}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>

              <div>
                <label htmlFor="phExpiryDays" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiClock className="text-black" size={16} />
                  <span className="ml-2">Expiry Block Days</span>
                </label>
                <input
                  type="number"
                  name="phExpiryDays"
                  id="phExpiryDays"
                  placeholder="Enter expiry days"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phExpiryDays}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>


              <div>
                <label htmlFor="phDefaultOutlet" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiMap className="text-black" size={16} />
                  <span className="ml-2">Default Outlet</span>
                </label>
                <select
                  name="phDefaultOutlet"
                  id="phDefaultOutlet"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phDefaultOutletId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedOutlet = outlets.find(outlet => outlet.ID.toString() === selectedId);
                    formik.setFieldValue('phDefaultOutletId', selectedId);
                    formik.setFieldValue('phDefaultOutlet', selectedOutlet ? selectedOutlet.Name : '');
                  }}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Outlet</option>
                  {outlets.map((outlet) => (
                    <option key={outlet.ID} value={outlet.ID}>{outlet.Name}</option>
                  ))}
                </select>
              </div>




            </div>
          </div>

          {/* Bill Settings Section */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <SectionTitle icon={<FiFileText className="text-indigo-600" />} title="Bill Settings" />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <label htmlFor="phAutoBillPrint" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Auto Bill Print</span>
                </label>
                <select
                    name="phAutoBillPrint"
                    id="phAutoBillPrint"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phAutoBillPrint ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phAutoBillPrint', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>


              <div>
                <label htmlFor="phValueRoundOff" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Auto Round Off</span>
                </label>
                <select
                    name="phValueRoundOff"
                    id="phValueRoundOff"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phValueRoundOff ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phValueRoundOff', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="PhMedicineFilterType" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Medicine Filter Type</span>
                </label>
                <select
                  name="PhMedicineFilterType"
                  id="PhMedicineFilterType"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"

                  value={formik.values.PhMedicineFilterType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Option</option>
                  <option value="all">All</option>
                  <option value="item">Item Name</option>
                  <option value="chemical">Chemical</option>
                </select>
              </div>

              <div>
                <label htmlFor="GlobalDiscountonSales" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Ask Save Default Discount on Sales</span>
                </label>
                <select
                  name="GlobalDiscountonSales"
                  id="GlobalDiscountonSales"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.GlobalDiscountonSales || 'No'}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              
              <div>
                <label htmlFor="phBillType" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiCheckSquare className="text-black" size={16} />
                  <span className="ml-2">Bill Type</span>
                </label>
                <select
                  name="phBillType"
                  id="phBillType"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phBillType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Option</option>
                  <option value="Normal">Normal</option>
                  <option value="DOTMATRIX">DOTMATRIX</option>
                  <option value="KOT">KOT</option>
                </select>
              </div>


              <div>
                <label htmlFor="phBillTemplate" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiCheckSquare className="text-black" size={16} />
                  <span className="ml-2">Bill Template</span>
                </label>
                <select
                  name="phBillTemplate"
                  id="phBillTemplate"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phBillTemplate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Option</option>
                  <option value="A5">A5</option>
                  <option value="KOT">KOT</option>
                </select>
              </div>


              <div>
                <label htmlFor="phpaymentMarkOnBillSave" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Payment Mark on bill save</span>
                </label>
                <select
                    name="phpaymentMarkOnBillSave"
                    id="phpaymentMarkOnBillSave"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phpaymentMarkOnBillSave ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phpaymentMarkOnBillSave', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phPrinterType" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiPrinter className="text-black" size={16} />
                  <span className="ml-2">Printer Type</span>
                </label>
                <select
                  name="phPrinterType"
                  id="phPrinterType"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phPrinterType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Option</option>
                  <option value="EPSON">EPSON</option>
                  <option value="TVS">TVS</option>
                </select>
              </div>


              <div>
                <label htmlFor="phPrinterWidth" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiPrinter className="text-black" size={16} />
                  <span className="ml-2">Printer Width</span>
                </label>
                <input
                  type="number"
                  name="phPrinterWidth"
                  id="phPrinterWidth"
                  placeholder="Enter printer width"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phPrinterWidth}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>  

              
              <div>
                <label htmlFor="phFeedinLines" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiPrinter className="text-black" size={16} />
                  <span className="ml-2">Feed In Lines</span>
                </label>
                <input
                  type="number"
                  name="phFeedinLines"
                  id="phFeedinLines"
                  placeholder="Enter feed in lines"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phFeedinLines}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>  

              <div>
                <label htmlFor="phFeedInForward" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiPrinter className="text-black" size={16} />
                  <span className="ml-2">Feed In Forward</span>
                </label>
                <input
                  type="number"
                  name="phFeedInForward"
                  id="phFeedInForward"
                  placeholder="Enter feed in forward"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phFeedInForward}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>  

              <div>
                <label htmlFor="phFeedOutLines" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiPrinter className="text-black" size={16} />
                  <span className="ml-2">Feed Out Lines</span>
                </label>
                <input
                  type="number"
                  name="phFeedOutLines"

                  id="phFeedOutLines"
                  placeholder="Enter feed out lines"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phFeedOutLines}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>

              <div>
                <label htmlFor="phFeedOutForward" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiPrinter className="text-black" size={16} />
                  <span className="ml-2">Feed Out Forward</span>
                </label>
                <input
                  type="number"
                  name="phFeedOutForward"
                  id="phFeedOutForward"
                  placeholder="Enter feed out forward"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.phFeedOutForward}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>  




              <div>
                <label htmlFor="GbAutoBillPrint" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Auto General Bill Print</span>
                </label>
                <select
                  name="GbAutoBillPrint"
                  id="GbAutoBillPrint"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.GbAutoBillPrint ? 'true' : 'false'}
                  onChange={(e) => formik.setFieldValue('GbAutoBillPrint', e.target.value === 'true')}
                  onBlur={formik.handleBlur}
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="GbBillTemplate" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">General Bill Template</span>
                </label>
                <select
                  name="GbBillTemplate"
                  id="GbBillTemplate"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.GbBillTemplate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Option</option>
                  <option value="A5">A5</option>
                  <option value="KOT">KOT</option>
                </select>
              </div>


              <div>
                <label htmlFor="GbBillType" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">General Bill Type</span>
                </label>
                <select
                  name="GbBillType"
                  id="GbBillType"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  value={formik.values.GbBillType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Choose Option</option>
                  <option value="Normal">Normal</option>
                  <option value="DOTMATRIX">DOTMATRIX</option>
                  <option value="KOT">KOT</option>
                </select>
              </div>

              <div>
                <label htmlFor="GbPaymentMarkOnBillSave" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Payment Mark on general bill save</span>
                </label>
                <select
                  name="GbPaymentMarkOnBillSave"
                  id="GbPaymentMarkOnBillSave"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"

                  value={formik.values.GbPaymentMarkOnBillSave ? 'true' : 'false'}
                  onChange={(e) => formik.setFieldValue('GbPaymentMarkOnBillSave', e.target.value === 'true')}
                  onBlur={formik.handleBlur}
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phShowFirmname" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Show firm name</span>
                </label>
                <select
                    name="phShowFirmname"
                    id="phShowFirmname"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phShowFirmname ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phShowFirmname', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phShowFirmnumber" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Show phone numbers</span>
                </label>
                <select
                    name="phShowFirmnumber"
                    id="phShowFirmnumber"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phShowFirmnumber ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phShowFirmnumber', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phShowAddress" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Show Address</span>
                </label>
                <select
                    name="phShowAddress"
                    id="phShowAddress"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phShowAddress ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phShowAddress', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phShowGst" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Show GST number</span>
                </label>
                <select
                    name="phShowGst"
                    id="phShowGst"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phShowGst ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phShowGst', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phShowWorkingHourse" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Show working hours</span>
                </label>
                <select
                    name="phShowWorkingHourse"
                    id="phShowWorkingHourse"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phShowWorkingHourse ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phShowWorkingHourse', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>

              <div>
                <label htmlFor="phShowUsername" className="text-sm font-medium text-black mb-2 flex items-center">
                  <FiAlertCircle className="text-black" size={16} />
                  <span className="ml-2">Show user name</span>
                </label>
                <select
                    name="phShowUsername"
                    id="phShowUsername"
                    className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    value={formik.values.phShowUsername ? 'true' : 'false'}
                    onChange={(e) => formik.setFieldValue('phShowUsername', e.target.value === 'true')}
                    onBlur={formik.handleBlur}
                >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                </select>
              </div>
            </div>
          </div>

          
          <div className="flex justify-end pt-2">
            <button 
              type="submit" 
              disabled={loading}
              className="flex items-center px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium rounded-lg shadow hover:from-indigo-700 hover:to-purple-700 transition-all duration-200"
            >
              <FiSave className="mr-2" />
              Save Settings
            </button>
          </div>
        </form>
      </div>
    );
};

export default AdminSettings;